import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const UploadPanelStyles = makeStyles(({ colors }: Theme) => createStyles({
  root: {
    zIndex: 2147483100,
    position: 'fixed',
    bottom: 10,
    right: 10,
    maxHeight: 330,
    maxWidth: 400,
    width: '100%',
  },
  uploadIcon: {
    color: '#3B9ED8',
    height: 16,
    verticalAlign: 'middle',
    marginRight: 6,
    width: 'unset',
  },
  downloadIcon: {
    color: '#8324B2',
    height: 16,
    verticalAlign: 'middle',
    marginRight: 6,
    width: 'unset',
  },
  header: {
    background: '#26325F',
    color: '#FFF',
    fontSize: 16,
  },
  expanded: {
    transform: 'rotate(180deg)',
  },
  icon: {
    fontSize: 30,
    color: '#FFF',
    verticalAlign: 'middle',
  },
  actionContainer: {
    marginLeft: 'auto',
  },
  preview: {
    padding: '4px 0px',
    borderBottom: `1px solid ${colors.border}`,
  },
  action: {
    color: '#DCDEE5',
    padding: 0,
    marginLeft: 4,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
  },
  headerAction: {
    padding: 0,
    marginLeft: 10,
  },
  errorIcon: {
    fontSize: 20,
    color: '#FF6C00',
    verticalAlign: 'middle',
  },
  completeIcon: {
    fontSize: 20,
    color: '#00AD8D',
    verticalAlign: 'middle',
  },
  detailPanel: {
    height: 230,
    padding: 8,
    overflow: 'auto',
    alignItems: 'baseline',
  },
  titleContainer: {
    maxWidth: 260,
    wordBreak: 'break-all',
  },
  modalTitle: {
    fontSize: 24,
    color: '#263245',
    fontFamily: 'Montserrat',
  },
  modalText: {
    fontSize: 16,
    fontFamily: 'Roboto Regular',
  },
  continueAction: {
    color: '#018694',
    borderColor: '#018694',
    textTransform: 'unset',
  },
  cancelAction: {
    color: '#F8221A',
    borderColor: '#F8221A',
    textTransform: 'unset',
  },
}), { name: 'UploadPanel' });
